import { Box, Step, StepLabel, Stepper } from "@mui/material";

const steps = [
  "Organization",
  "Clinic",
  "Service Type",
  "User",
  "Hp Appointment Schedule",
  "Payment",
];

const Progress = (props: any) => {
  return (
    <Box sx={{ width: "100%", marginBottom: "20px" }}>
      <Stepper activeStep={props.activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default Progress;
